module.exports = __webpack_public_path__ + "static/media/business-man.cd3014db.svg";